export const iconList = [
  {
    name: 'Images',
    icons: [
      'PhotoIcon',
      'ComponentIcon',
      'GridIcon',
      'OutlineIcon',
      'PhotoDragIcon',
      'PhotoStabilizeIcon',
      'CameraStabilizeIcon',
      'GridAltIcon',
      'SearchIcon',
      'ZoomIcon',
      'ZoomOutIcon',
      'ZoomResetIcon',
      'EyeIcon',
      'EyeCloseIcon',
      'LightningIcon',
      'LightningOffIcon',
      'MirrorIcon',
      'GrowIcon',
      'ContrastIcon',
      'SwitchAltIcon',
      'ContrastIgnoredIcon',
      'PaintBrushIcon',
      'RulerIcon',
      'CameraIcon',
      'VideoIcon',
      'SpeakerIcon',
      'PlayIcon',
      'PlayBackIcon',
      'PlayNextIcon',
      'RewindIcon',
      'FastForwardIcon',
      'StopAltIcon',
      'SunIcon',
      'MoonIcon',
      'StopAltHollowIcon',
      'PlayHollowIcon',
      'PlayAllHollowIcon',
      'StopIcon',
      'SideBySideIcon',
      'StackedIcon',
    ]
  },
  {
    name: 'Documents',
    icons: [
      'BookIcon',
      'DocumentIcon',
      'CopyIcon',
      'CategoryIcon',
      'FolderIcon',
      'PrintIcon',
      'GraphLineIcon',
      'CalendarIcon',
      'GraphBarIcon',
      'AlignLeftIcon',
      'AlignRightIcon',
      'FilterIcon',
      'DocChartIcon',
      'DocListIcon',
      'DragIcon',
      'MenuIcon',
    ]
  },
  {
    name: 'Editing',
    icons: [
      'MarkupIcon',
      'BoldIcon',
      'ItalicIcon',
      'PaperClipIcon',
      'ListOrderedIcon',
      'ListUnorderedIcon',
      'ParagraphIcon',
      'MarkdownIcon',
    ]
  },
  {
    name: 'Git',
    icons: [
      'RepoIcon',
      'CommitIcon',
      'BranchIcon',
      'PullRequestIcon',
      'MergeIcon',
    ]
  },
  {
    name: 'OS',
    icons: [
      'AppleIcon',
      'LinuxIcon',
      'UbuntuIcon',
      'WindowsIcon',
      'ChromeIcon',
    ]
  },
  {
    name: 'Logos',
    icons: [
      'StorybookIcon',
      'AzureDevOpsIcon',
      'BitbucketIcon',
      'ChromaticIcon',
      'ComponentDrivenIcon',
      'DiscordIcon',
      'FacebookIcon',
      'FigmaIcon',
      'GDriveIcon',
      'GithubIcon',
      'GitlabIcon',
      'GoogleIcon',
      'GraphqlIcon',
      'MediumIcon',
      'ReduxIcon',
      'TwitterIcon',
      'YoutubeIcon',
      'VSCodeIcon',
      'LinkedinIcon',
      'XIcon',
    ]
  },
  {
    name: 'Devices',
    icons: [
      'BrowserIcon',
      'TabletIcon',
      'MobileIcon',
      'WatchIcon',
      'SidebarIcon',
      'SidebarAltIcon',
      'SidebarAltToggleIcon',
      'SidebarToggleIcon',
      'BottomBarIcon',
      'BottomBarToggleIcon',
      'CPUIcon',
      'DatabaseIcon',
      'MemoryIcon',
      'StructureIcon',
      'BoxIcon',
      'PowerIcon',
    ]
  },
  {
    name: 'CRUD',
    icons: [
      'EditIcon',
      'CogIcon',
      'NutIcon',
      'WrenchIcon',
      'EllipsisIcon',
      'WandIcon',
      'SweepIcon',
      'CheckIcon',
      'FormIcon',
      'BatchDenyIcon',
      'BatchAcceptIcon',
      'ControlsIcon',
      'PlusIcon',
      'CloseAltIcon',
      'CrossIcon',
      'TrashIcon',
      'PinAltIcon',
      'UnpinIcon',
      'AddIcon',
      'SubtractIcon',
      'CloseIcon',
      'DeleteIcon',
      'PassedIcon',
      'ChangedIcon',
      'FailedIcon',
      'ClearIcon',
      'CommentIcon',
      'CommentAddIcon',
      'RequestChangeIcon',
      'CommentsIcon',
      'ChatIcon',
      'LockIcon',
      'UnlockIcon',
      'KeyIcon',
      'OutboxIcon',
      'CreditIcon',
      'ButtonIcon',
      'TypeIcon',
      'PointerDefaultIcon',
      'PointerHandIcon',
      'CommandIcon',
      'SaveIcon',
    ]
  },
  {
    name: 'Communicate',
    icons: [
      'InfoIcon',
      'QuestionIcon',
      'SupportIcon',
      'AlertIcon',
      'AlertAltIcon',
      'EmailIcon',
      'PhoneIcon',
      'LinkIcon',
      'LinkBrokenIcon',
      'BellIcon',
      'RSSIcon',
      'ShareAltIcon',
      'ShareIcon',
      'JumpToIcon',
      'CircleHollowIcon',
      'CircleIcon',
      'BookmarkHollowIcon',
      'BookmarkIcon',
      'DiamondIcon',
      'HeartHollowIcon',
      'HeartIcon',
      'StarHollowIcon',
      'StarIcon',
      'CertificateIcon',
      'VerifiedIcon',
      'ThumbsUpIcon',
      'ShieldIcon',
      'BasketIcon',
      'BeakerIcon',
      'HourglassIcon',
      'FlagIcon',
      'CloudHollowIcon',
      'CloudIcon',
      'StickerIcon',
      'StatusFailIcon',
      'StatusIcon',
      'StatusWarnIcon',
      'StatusPassIcon',
    ]
  },
  {
    name: 'Wayfinding',
    icons: [
      'ChevronUpIcon',
      'ChevronDownIcon',
      'ChevronLeftIcon',
      'ChevronRightIcon',
      'ChevronSmallUpIcon',
      'ChevronSmallDownIcon',
      'ChevronSmallLeftIcon',
      'ChevronSmallRightIcon',
      'ArrowUpIcon',
      'ArrowDownIcon',
      'ArrowLeftIcon',
      'ArrowRightIcon',
      'ArrowTopLeftIcon',
      'ArrowTopRightIcon',
      'ArrowBottomLeftIcon',
      'ArrowBottomRightIcon',
      'ArrowSolidUpIcon',
      'ArrowSolidDownIcon',
      'ArrowSolidLeftIcon',
      'ArrowSolidRightIcon',
      'ExpandAltIcon',
      'CollapseIcon',
      'ExpandIcon',
      'UnfoldIcon',
      'TransferIcon',
      'RedirectIcon',
      'UndoIcon',
      'ReplyIcon',
      'SyncIcon',
      'UploadIcon',
      'DownloadIcon',
      'BackIcon',
      'ProceedIcon',
      'RefreshIcon',
      'GlobeIcon',
      'CompassIcon',
      'LocationIcon',
      'PinIcon',
      'TimeIcon',
      'DashboardIcon',
      'TimerIcon',
      'HomeIcon',
      'AdminIcon',
      'DirectionIcon',
    ]
  },
  {
    name: 'People',
    icons: [
      'UserIcon',
      'UserAltIcon',
      'UserAddIcon',
      'UsersIcon',
      'ProfileIcon',
      'FaceHappyIcon',
      'FaceNeutralIcon',
      'FaceSadIcon',
      'AccessibilityIcon',
      'AccessibilityAltIcon',
      'AccessibilityIgnoredIcon',
    ]
  },
];
